// extracted by mini-css-extract-plugin
module.exports = {"container":"XY1ijAsWdXUcXAM0CT6Qq"};